import { Injectable } from '@angular/core';
import { HttpHeaders } from '@angular/common/http';

@Injectable()
export class HttpHeadersService {

  constructor() { }
  httpOptions: any;
  getCommonHttpHeaders(v2_api?:string) {
    var token_key;
    if (v2_api){
      token_key = localStorage.getItem('token_key_v2');  
    }
    else{
      token_key = localStorage.getItem('token_key');    
    }
       
    this.httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Authorization': 'Bearer ' + token_key
      })
    };
    return this.httpOptions
  }

  getLoginHttpHeaders() {
    this.httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'portal': 'admin'
      })
    };
    return this.httpOptions
  }

}
